import style from './logout.module.scss'
import { OutlinedButton } from '../ui/button'
import React from 'react'
import { Link } from 'react-router-dom'

interface LogoutProps {
  className?: string
}

export const Logout = ({ className }: LogoutProps): React.ReactElement => {
  return (
    <OutlinedButton asChild size="sm" className={`border-danger w-fit ${style.logout} ${className || ''}`}>
      <Link to="/sign-out">Log out</Link>
    </OutlinedButton>
  )
}
